<template>
  <div
    class="movement-sidebar"
    :class="{ open: sidebarOpen && isMovement, 'marker-closed': isMovement && !sidebarOpen }"
  >
    <div class="art-navigation movement-pagination" v-if="group.length">
      <div class="pagination">
        <a @click.stop.prevent="setMovement(groupIndex - 1)" class="prev" :class="{ disabled: groupIndex === 0 }">
          <i class="icon-PREVIOUS"></i>
        </a>
        <span class="counter">{{ groupIndex + 1 }}/{{ group.length }} mouvements</span>
        <a
          @click.stop.prevent="setMovement(groupIndex + 1)"
          class="next"
          :class="{ disabled: groupIndex + 1 === group.length }"
        >
          <i class="icon-Next"></i>
        </a>
      </div>
    </div>
    <perfect-scrollbar
      class="movement-sidebar-inner scroll-always-visible"
      ref="ps"
      v-if="isMovement"
      :options="scrollOptions"
    >
      <div class="tools" v-show="!note">
        <div class="share-print">
          <a href class="expand" @click.prevent.stop>
            <i class="icon-forms"></i>
          </a>
          <a @click.prevent="share(movement)" class="share" v-b-tooltip.hover.left :title="titles.share">
            <i class="icon-partager"></i>
          </a>
          <TextNoteLink
            :resource="movement"
            type="movement"
            v-if="$can('create', 'text_note')"
            :title="titles.create"
            icon="Notice_New"
          ></TextNoteLink>
        </div>
      </div>
      <MovementSidebarDetailsDeposit v-if="isDeposit" :movement="movement" v-on:imagesLoad="updateScroll" />
      <MovementSidebarDetailsExhibition v-if="isExhibition" :movement="movement" v-on:imagesLoad="updateScroll" />
    </perfect-scrollbar>
    <button class="movement-toggle-button" @click.stop.prevent="toggleSidebar()" v-if="isMovement">
      <i class="fa fa-caret-right"></i>
    </button>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import MovementSidebarDetailsExhibition from './MovementSidebarDetailsExhibition.vue';
import MovementSidebarDetailsDeposit from './MovementSidebarDetailsDeposit.vue';
import TextNoteLink from './TextNoteLink.vue';
import abilitiesMixin from 'mixins/abilitiesMixin.js';
import shareMixin from 'mixins/shareMixin.js';
import seoMetadata from 'mixins/seoMetadata';

export default {
  name: 'MovementSidebar',
  props: {
    group: {
      default: () => [],
      type: Array,
    },
  },
  components: {
    MovementSidebarDetailsExhibition,
    MovementSidebarDetailsDeposit,
    TextNoteLink,
  },
  mixins: [seoMetadata, abilitiesMixin, shareMixin],
  methods: {
    ...mapMutations('textNotes', { assignTextNote: 'assign' }),
    ...mapActions('textNotes', { readTextNote: 'read' }),
    setMovement(index) {
      if (index >= this.group.length || index < 0) {
        return;
      } else {
        this.groupIndex = index;
        this.$emit('setMovement', this.group[index]);
      }
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    updateScroll() {
      setTimeout(() => {
        this.$refs.ps.ps.update();
      }, 200);
    },
  },
  computed: {
    ...mapGetters('artworks', {
      movement: 'artwork',
    }),
    ...mapState('route', ['query']),
    isExhibition() {
      return this.partialType === 'exhibition';
    },
    isDeposit() {
      return this.partialType === 'deposit';
    },
    partialType() {
      const { movement_category_key } = this.movement;
      return movement_category_key;
    },
    isMovement() {
      return Object.keys(this.movement).length !== 0;
    },
    note() {
      return this.$route.query.note;
    },
    titles() {
      return {
        create: this.$gettext('Créer une nouvelle notice rédactionnelle'),
        share: this.$gettext('Partager'),
      };
    },
  },
  watch: {
    'query.note': function (newValue, oldValue) {
      if (newValue) {
        this.readTextNote(newValue);
      } else {
        this.assignTextNote({ name: 'textNote', data: null });
      }
    },
    movement: function (newMovement, oldMovement) {
      this.sidebarOpen = true;
      const { note } = this.query;

      if (newMovement?._id != oldMovement?._id) {
        this.assignTextNote({ name: 'textNote', data: null });
        if (note) {
          if (!this.textNote) {
            this.readTextNote(note);
            return;
          }
          if (note !== this.textNote.id) {
            this.readTextNote(note);
          }
        }
      }
    },
    group: function (ng, og) {
      if (ng !== og) {
        this.groupIndex = 0;
      }
    },
  },
  data() {
    return {
      scrollOptions: {
        wheelPropagation: true,
        suppressScrollX: true,
      },
      sidebarOpen: true,
      showGroup: false,
      groupIndex: 0,
    };
  },
  metaInfo() {
    return {
      ...this.metaConfig({
        title: this.metaMovementTitle,
        titleTemplate: this.metaTitleTemplate,
      }),
    };
  },
};
</script>

<style lang="less">
@import '~bootstrap-less-port/less/bootstrap-grid';
@grid-gutter-width: 0px;
#media-breakpoint-down(
  sm,
  { 
    .movement-sidebar {
      width: 90%;
      left: -90%;

      &.marker-closed {
        left: -90%;
      }
    }
  }
);

.tools {
  padding: 0px;
  border: 0px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;
}

.tool-links {
  border: 1px solid @artwork-sidebar-tools-border;
  position: absolute;
  top: -1px;
  right: 16px;
  padding: 0 !important;

  a {
    display: block;
    width: 34px;
    height: 34px;
    padding: 0;
    margin: 0;
    line-height: 0;
    text-align: center;
  }
}

.share-print {
  position: absolute;
  border: 1px solid @artwork-sidebar-tools-border;
  top: -1px;
  right: 15px;
  padding: 0 !important;
  z-index: 100;
  background-color: @artwork-sidebar-tools-background;

  &:hover {
    border: 2px solid @artwork-sidebar-share-print-border;
    top: -2px;
    right: 14px;
    display: flex;
    flex-direction: column;
    a {
      display: block;
    }
  }

  a.expand {
    display: block;
    width: 34px;
    height: 34px;
    text-align: center;
    padding: 0;
    margin: 0;
    line-height: 0;
    .icon-forms {
      font-size: 28px;
      line-height: 36px;
    }
  }

  a {
    display: none;
    width: 34px;
    height: 34px;
    text-align: center;
    padding: 0;
    margin: 0;
    line-height: 0;
  }
}
</style>
